




























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { Course } from '../models/grade-viewmodels';
import { IDictionary } from '@/shared/models/interface/dictionary-model';

import { formatDate } from '@/shared/filters/dates';

@Component({
    computed: {
        ...mapGetters('root', ['label'])
    },
    filters: {
        formatDate
    }
})
export default class Modules extends Vue {
    @Prop() courses!: Course[];
    @Prop() year!: string;
    @Prop() id!: string;

    private isOpen: boolean = false;
    private by: string = 'period';
    private order: string = 'asc';
    private labelModule = 'ModuleOverview';

    get sortedModules(): Course[] {
      return this.courses.sort((a: IDictionary<any>, b: IDictionary<any>) => {
            let aCompare = a[this.by];
            let bCompare = b[this.by];

            if (this.by === 'grade') {
              //Grades need to be ordered 10-1, then letered grades and then blank
              //This field is a string field so normally 10,0 comes after 9,0 and 8,0 when doing a normal sort
              //To fix the sorting, we prefix the string so the alphabetix ordering is correct
              // - 10,0 does not need a prefix
              // - 0 prefix for 9,0, 8,0 etc (this is detected by checking if the second character is a comma)
              // - -2 for the lettered grades (checked if the first character is NaN)
              // - -1 is used for a blank string (('' || -1) returns -1)
              // the list then becomes 10,0  09,0  08,0  -2G  -2NS  -1
              //First fix 10,0 < 9,0 by prefixing with '0'
              aCompare = aCompare.indexOf(',') === 1 ? '0' + aCompare : aCompare;
              bCompare = bCompare.indexOf(',') === 1 ? '0' + bCompare : bCompare;
              //Lettered grades come after the numbered, prefix with -2
              aCompare = aCompare !== '' && isNaN(aCompare.charAt(0)) ? '-2' + aCompare : aCompare;
              bCompare = bCompare !== '' && isNaN(bCompare.charAt(0)) ? '-2' + bCompare : bCompare;
              //Empty strings last
              aCompare = aCompare || '-1';
              bCompare = bCompare || '-1';
            }

            if (aCompare < bCompare) {
                return this.order === 'asc' ? -1 : 1; 
            }

            if (aCompare > bCompare) {
                return this.order === 'asc' ? 1 : -1;    
            }

            return 0;
        });
    }

    private togglePartial(e: Event, mod: Course): void {
        e.stopPropagation();
        mod.isOpen = !mod.isOpen;
    }

    private openResultDetail(mod: Course): void {
        this.$store.commit('setModuleDetail', undefined);
        this.$store.commit('root/setPopupComponent', {
            name: 'ModuleResults',
            data: {
                studyId: this.id,
                bookedModuleId: mod.bookedModuleId,
                year: this.year
            }
        });
    }

    private sortBy(by: string): void {
        if (this.by !== by) {
            this.by = by;
            this.order = 'asc'
        } else {
            this.order = this.order === 'asc' ? 'desc' : 'asc';
        }
    }
}
